/**
 * Product Leads API class
 * Handles all product-leads-related API calls
 */

import { BaseApi } from './base.api';
import { LOS_API_BASE_URL } from '@/config';
import type {
    GetProductLeadsRequest,
    GetProductLeadsResponse,
} from '@/types/productLeads.types';

export class ProductLeadsApi extends BaseApi {
    constructor() {
        super(LOS_API_BASE_URL);
    }

    /**
     * Get product leads for an agent (and its sub-agents).
     * selfOnboard returns all leads. Endpoint: POST /products/leads
     */
    async getProductLeads(
        request: GetProductLeadsRequest
    ): Promise<GetProductLeadsResponse> {
        try {
            const response = await this.post<GetProductLeadsResponse>(
                '/products/leads',
                request,
                true
            );

            if (response.success && response.data) {
                return response.data;
            }

            return {
                message: response.message || 'Failed to fetch product leads',
                response: [],
            };
        } catch (error) {
            const apiError = this.handleError(error);
            return {
                message:
                    apiError.message ||
                    'Failed to fetch product leads. Please try again.',
                response: [],
            };
        }
    }
}

// Singleton instance
export const productLeadsApi = new ProductLeadsApi();
